declare global {
  interface Window {
    __APP_CONFIG__?: {
      VDR_URL?: string;
      OTP_URL?: string;
      COMPANY_ID?: string;
    };
  }
}

const appConfig = window.__APP_CONFIG__ ?? {};

export const config = {
  vdrUrl: appConfig.VDR_URL ?? '',
  otpUrl: appConfig.OTP_URL ?? '',
  companyId: appConfig.COMPANY_ID ?? '',
};